import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

// Um arquivo pendente é {nome, situacao, detalhe, dataEnvio}. A forma antiga — lista de
// strings — ainda chega de um Web que não tenha subido junto, e é convertida aqui para as
// telas não precisarem saber de qual versão vieram.
const normalizarPendentes = arquivos => (arquivos || []).map(a => (
  typeof a === 'string' ? { nome: a, situacao: '', detalhe: '', dataEnvio: '' } : a
));

const normalizarEnvio = dados => ({
  arquivos: normalizarPendentes(dados && dados.arquivos),
  isaacConfigurado: !(dados && dados.isaacConfigurado === false),
  motivoIsaac: (dados && dados.motivoIsaac) || '',
});

export default {
  iniciarSessao: token => {
    return Vue.http.post('/api/acessoConciliacao/Sessao', { token })
      .then(resposta => resposta.data);
  },
  lista: (pagina = 1, filtros = {}, todos = false) => {
    const parametros = Object.assign({}, { pagina, todos }, filtros);
    return Vue.http.get('/api/conciliacaoProjeto', { params: parametros })
      .then(resposta => resposta.data);
  },
  projetos: (todos = false, situacaoProjeto = 0) => {
    return Vue.http.get('/api/conciliacaoProjeto/Projetos', { params: { todos, situacaoProjeto } })
      .then(resposta => resposta.data);
  },
  exportarLista: (filtros = {}, todos = false) => {
    const parametros = Object.assign({}, { todos }, filtros);
    return Vue.http.get('/api/conciliacaoProjeto/Exportar', { params: parametros })
      .then(resposta => resposta.data);
  },
  responsaveis: () => {
    return Vue.http.get('/api/conciliacaoProjeto/Responsaveis')
      .then(resposta => resposta.data);
  },
  previaProcessamento: (reprocessarTudo = false, todos = false) => {
    return Vue.http.get('/api/conciliacaoProjeto/Processar', { params: { reprocessarTudo, todos } })
      .then(resposta => resposta.data);
  },
  processarProjetos: (cursor = 0, reprocessarTudo = false, todos = false) => {
    return Vue.http.post('/api/conciliacaoProjeto/Processar', {}, { params: { cursor, reprocessarTudo, todos } })
      .then(resposta => resposta.data);
  },
  configuracaoProjeto: () => {
    return Vue.http.get('/api/conciliacaoProjeto/Configuracao')
      .then(resposta => resposta.data);
  },
  salvarConfiguracaoProjeto: payload => {
    return Vue.http.post('/api/conciliacaoProjeto/Configuracao', payload)
      .then(resposta => resposta.data);
  },
  comDiferencaBanco: (filtros = {}) => {
    return Vue.http.get('/api/conciliacaoBanco/ComDiferenca', { params: filtros })
      .then(resposta => resposta.data);
  },
  listaBanco: (pagina = 1, filtros = {}, todos = false) => {
    const parametros = Object.assign({}, { pagina, todos }, filtros);
    return Vue.http.get('/api/conciliacaoBanco', { params: parametros })
      .then(resposta => resposta.data);
  },
  exportarListaBanco: (filtros = {}, todos = false) => {
    return Vue.http.get('/api/conciliacaoBanco/Exportar', { params: Object.assign({}, { todos }, filtros) })
      .then(resposta => resposta.data);
  },
  tarifasBordero: (de = '', ate = '', ocultarTarifados = true) => {
    return Vue.http.get('/api/conciliacaoBanco/Tarifas', { params: { de, ate, ocultarTarifados } })
      .then(resposta => resposta.data);
  },
  gerarTarifasBordero: payload => {
    return Vue.http.post('/api/conciliacaoBanco/Tarifas/Gerar', payload)
      .then(resposta => resposta.data);
  },
  modelosRateioPlanilha: () => {
    return Vue.http.get('/api/conciliacaoBanco/RateioPlanilha/Modelos')
      .then(resposta => resposta.data);
  },
  lerRateioPlanilha: (modelo, arquivo, escolhas) => {
    const dados = new FormData();
    dados.append('modelo', modelo);
    dados.append('arquivo', arquivo, arquivo.name);
    dados.append('escolhas', JSON.stringify(escolhas || []));
    return Vue.http.post('/api/conciliacaoBanco/RateioPlanilha/Ler', dados)
      .then(resposta => resposta.data);
  },
  lancamentosRateioPlanilha: (valor, data, texto) => {
    return Vue.http.get('/api/conciliacaoBanco/RateioPlanilha/Lancamentos', { params: { valor, data, texto } })
      .then(resposta => resposta.data);
  },
  aplicarRateioPlanilha: (modelo, arquivo, escolhas) => {
    const dados = new FormData();
    dados.append('modelo', modelo);
    dados.append('arquivo', arquivo, arquivo.name);
    dados.append('escolhas', JSON.stringify(escolhas || []));
    return Vue.http.post('/api/conciliacaoBanco/RateioPlanilha/Aplicar', dados)
      .then(resposta => resposta.data);
  },
  sugestoesTextoAplicacao: () => {
    return Vue.http.get('/api/conciliacaoBanco/TextosAplicacao')
      .then(resposta => resposta.data);
  },
  confirmarTextosAplicacao: textos => {
    return Vue.http.post('/api/conciliacaoBanco/TextosAplicacao/Confirmar', { textos })
      .then(resposta => resposta.data);
  },
  rejeitarTextosAplicacao: textos => {
    return Vue.http.post('/api/conciliacaoBanco/TextosAplicacao/Rejeitar', { textos })
      .then(resposta => resposta.data);
  },
  previaProcessamentoBanco: () => {
    return Vue.http.get('/api/conciliacaoBanco/Processar')
      .then(resposta => resposta.data);
  },
  processarBanco: (cursor = 0) => {
    return Vue.http.post('/api/conciliacaoBanco/Processar', {}, { params: { cursor } })
      .then(resposta => resposta.data);
  },
  contas: (todos = false) => {
    return Vue.http.get('/api/conciliacaoBanco/Contas', { params: { todos } })
      .then(resposta => resposta.data);
  },
  creditosIdentificados: (filtros = {}) => {
    return Vue.http.get('/api/conciliacaoBanco/CreditosIdentificados', { params: filtros })
      .then(resposta => resposta.data);
  },
  contexto: (idProjetoCript, dataIni = '', dataFim = '') => {
    return Vue.http.get(`/api/conciliacaoProjeto/${idProjetoCript}/Contexto`, { params: { dataIni, dataFim } })
      .then(resposta => resposta.data);
  },
  dados: (idProjetoCript, dataIni = '', dataFim = '', processar = false) => {
    return Vue.http.get(`/api/conciliacaoProjeto/${idProjetoCript}/Dados`, { params: { dataIni, dataFim, processar } })
      .then(resposta => resposta.data);
  },
  conciliar: (idProjetoCript, payload) => {
    return Vue.http.post(`/api/conciliacaoProjeto/${idProjetoCript}/Conciliar`, payload)
      .then(resposta => resposta.data);
  },
  rateios: (idProjetoCript, idLancamento) => {
    return Vue.http.get(`/api/conciliacaoProjeto/${idProjetoCript}/Rateios`, { params: { idLancamento } })
      .then(resposta => resposta.data);
  },
  editarLancamento: (idProjetoCript, payload) => {
    return Vue.http.post(`/api/conciliacaoProjeto/${idProjetoCript}/EditarLancamento`, payload)
      .then(resposta => resposta.data);
  },
  criacaoLancamento: (idProjetoCript, idLancamento) => {
    return Vue.http.get(`/api/conciliacaoProjeto/${idProjetoCript}/CriacaoLancamento`, { params: { idLancamento } })
      .then(resposta => resposta.data);
  },
  vinculosTransitoria: (idProjetoCript, idLancamento) => {
    return Vue.http.get(`/api/conciliacaoProjeto/${idProjetoCript}/VinculosTransitoria`, { params: { idLancamento } })
      .then(resposta => resposta.data);
  },
  desfazer: (idProjetoCript, grupo) => {
    return Vue.http.post(`/api/conciliacaoProjeto/${idProjetoCript}/Desfazer`, { grupo })
      .then(resposta => resposta.data);
  },
  observacao: (idProjetoCript, payload) => {
    return Vue.http.post(`/api/conciliacaoProjeto/${idProjetoCript}/Observacao`, payload)
      .then(resposta => resposta.data);
  },
  contextoBanco: (idContaCript, dataReferencia = '') => {
    return Vue.http.get(`/api/conciliacaoProjeto/${idContaCript}/ContextoBanco`, { params: { dataReferencia } })
      .then(resposta => resposta.data);
  },
  dadosBanco: (idProjetoCript, dataIni = '', dataFim = '', processar = false, limite = 0, comCR = true) => {
    return Vue.http.get(`/api/conciliacaoProjeto/${idProjetoCript}/DadosBanco`, { params: { dataIni, dataFim, processar, limite, comCR } })
      .then(resposta => resposta.data);
  },
  ciclosSaque: (idContaCript, dataIni = '', dataFim = '') => {
    return Vue.http.get(`/api/conciliacaoProjeto/${idContaCript}/CiclosSaque`, { params: { dataIni, dataFim } })
      .then(resposta => resposta.data);
  },
  contasReceberConta: (idContaCript) => {
    return Vue.http.get(`/api/conciliacaoProjeto/${idContaCript}/ContasReceberConta`)
      .then(resposta => resposta.data);
  },
  contasReceberOutrasContas: (idContaCript, busca = '', valor = 0) => {
    return Vue.http.get(`/api/conciliacaoProjeto/${idContaCript}/ContasReceberOutrasContas`, { params: { busca, valor } })
      .then(resposta => resposta.data);
  },
  contasReceberAbertasVinculo: (idContaCript, filtro) => {
    return Vue.http.get(`/api/conciliacaoProjeto/${idContaCript}/ContasReceberAbertasVinculo`, { params: filtro })
      .then(resposta => resposta.data);
  },
  checkTaxa: (idContaCript, payload) => {
    return Vue.http.post(`/api/operacaoConciliacao/${idContaCript}/CheckTaxa`, payload)
      .then(resposta => resposta.data);
  },
  conciliarBanco: (idProjetoCript, payload) => {
    return Vue.http.post(`/api/conciliacaoProjeto/${idProjetoCript}/ConciliarBanco`, payload)
      .then(resposta => resposta.data);
  },
  desfazerBanco: (idProjetoCript, grupo) => {
    return Vue.http.post(`/api/conciliacaoProjeto/${idProjetoCript}/DesfazerBanco`, { grupo })
      .then(resposta => resposta.data);
  },
  excluirLinhaExtrato: (idContaCript, idExtrato) => {
    return Vue.http.post(`/api/conciliacaoProjeto/${idContaCript}/ExcluirLinhaExtrato`, { idExtrato })
      .then(resposta => resposta.data);
  },
  observacaoBanco: (idProjetoCript, payload) => {
    return Vue.http.post(`/api/conciliacaoProjeto/${idProjetoCript}/ObservacaoBanco`, payload)
      .then(resposta => resposta.data);
  },
  logConciliacaoBanco: (idContaCript, payload) => {
    return Vue.http.post(`/api/conciliacaoProjeto/${idContaCript}/LogConciliacaoBanco`, payload)
      .then(resposta => resposta.data);
  },
  diaUtilAnterior: () => {
    return Vue.http.get('/api/conciliacaoProjeto/DiaUtilAnterior')
      .then(resposta => resposta.data);
  },
  configuracaoAnexos: () => {
    return Vue.http.get('/api/anexoConciliacao/Configuracao')
      .then(resposta => resposta.data);
  },
  origemAnexoExtrato: (idExtrato, idLancamento) => {
    return Vue.http.get('/api/anexoConciliacao/Origens/Extrato', { params: { idExtrato: idExtrato || 0, idLancamento: idLancamento || 0 } })
      .then(resposta => resposta.data);
  },
  origemAnexoContasReceberVinculados: (ids) => {
    return Vue.http.get('/api/anexoConciliacao/Origens/ContasReceber/Vinculados', { params: { ids: (ids || []).join(',') } })
      .then(resposta => resposta.data);
  },
  origemAnexoContasReceber: (idPessoa) => {
    return Vue.http.get('/api/anexoConciliacao/Origens/ContasReceber', { params: { idPessoa } })
      .then(resposta => resposta.data);
  },
  contasExtratoAnexo: (busca = '') => {
    return Vue.http.get('/api/anexoConciliacao/Origens/ContasExtrato', { params: { busca } })
      .then(resposta => (resposta.data || []).map(c => ({ id: c.id, nome: c.nome })));
  },
  extratoContaAnexo: (idConta) => {
    return Vue.http.get('/api/anexoConciliacao/Origens/ExtratoConta', { params: { idConta } })
      .then(resposta => resposta.data);
  },
  extratosConta: (idConta) => {
    return Vue.http.get('/api/anexoConciliacao/ExtratosConta', { params: { idConta } })
      .then(resposta => resposta.data);
  },
  buscarContasReceberAnexo: (filtro) => {
    return Vue.http.get('/api/anexoConciliacao/Origens/ContasReceber/Busca', { params: filtro })
      .then(resposta => resposta.data);
  },
  lancamentosComArquivo: (ids) => {
    return Vue.http.post('/api/anexoConciliacao/Lancamentos/ComArquivo', ids || [])
      .then(resposta => resposta.data || []);
  },
  arquivosLancamento: (idLancamento) => {
    return Vue.http.get(`/api/anexoConciliacao/Lancamento/${idLancamento}/Arquivos`)
      .then(resposta => resposta.data);
  },
  arquivoLancamento: (idLancamento, fonte, nome) => {
    return Vue.http.get(`/api/anexoConciliacao/Lancamento/${idLancamento}/Arquivo`, { params: { fonte, nome }, responseType: 'blob' })
      .then(resposta => resposta.data);
  },
  arquivoOrigemAnexo: (origem, id, nome) => {
    return Vue.http.get('/api/anexoConciliacao/Origens/Arquivo', { params: { origem, id, nome }, responseType: 'blob' })
      .then(resposta => resposta.data);
  },
  enviarAnexos: (destino, ids, arquivos) => {
    const dados = new FormData();
    const referencias = (arquivos || []).filter(a => a && a.referencia);

    dados.append('ids', (ids || []).filter(i => i > 0).join(','));
    (arquivos || []).filter(a => a && !a.referencia).forEach(a => dados.append('arquivos', a, a.name));

    if (referencias.length)
      dados.append('referencias', JSON.stringify(referencias.map(r => ({ origem: r.origem, id: r.id, nome: r.nome }))));

    return Vue.http.post(`/api/anexoConciliacao/${destino}`, dados)
      .then(resposta => resposta.data);
  },
  configuracaoCredito: () => {
    return Vue.http.get('/api/creditoIdentificar/Configuracao')
      .then(resposta => resposta.data);
  },
  textosPadrao: () => {
    return Vue.http.get('/api/creditoIdentificar/TextosPadrao')
      .then(resposta => resposta.data);
  },
  salvarTextosPadrao: payload => {
    return Vue.http.post('/api/creditoIdentificar/TextosPadrao', payload)
      .then(resposta => resposta.data);
  },
  salvarConfiguracaoCredito: payload => {
    return Vue.http.post('/api/creditoIdentificar/Configuracao', payload)
      .then(resposta => resposta.data);
  },
  contasCredito: (idProjeto = 0, busca = '') => {
    return Vue.http.get('/api/creditoIdentificar/Contas', { params: { idProjeto, busca } })
      .then(resposta => resposta.data);
  },
  projetosCredito: (busca = '') => {
    return Vue.http.get('/api/creditoIdentificar/Projetos', { params: { busca } })
      .then(resposta => resposta.data);
  },
  rubricasCredito: (idProjeto = 0, busca = '', natureza = 'C') => {
    return Vue.http.get('/api/creditoIdentificar/Rubricas', { params: { idProjeto, busca, natureza } })
      .then(resposta => resposta.data);
  },
  subrubricasCredito: (idProjeto = 0, idRubrica = 0, busca = '', natureza = 'C') => {
    return Vue.http.get('/api/creditoIdentificar/Subrubricas', { params: { idProjeto, idRubrica, busca, natureza } })
      .then(resposta => resposta.data);
  },
  identificadoresExtrato: () => {
    return Vue.http.get('/api/creditoIdentificar/IdentificadoresExtrato')
      .then(resposta => resposta.data);
  },
  salvarIdentificadoresExtrato: itens => {
    return Vue.http.post('/api/creditoIdentificar/IdentificadoresExtrato', itens)
      .then(resposta => resposta.data);
  },
  contasGerais: (busca = '', excluirTransitorias = false) => {
    return Vue.http.get('/api/creditoIdentificar/ContasGerais', { params: { busca, excluirTransitorias } })
      .then(resposta => resposta.data);
  },
  rubricasGerais: (busca = '', natureza = 'D') => {
    return Vue.http.get('/api/creditoIdentificar/RubricasGerais', { params: { busca, natureza } })
      .then(resposta => resposta.data);
  },
  subrubricasGerais: (idRubrica = 0, busca = '', natureza = 'D') => {
    return Vue.http.get('/api/creditoIdentificar/SubrubricasGerais', { params: { idRubrica, busca, natureza } })
      .then(resposta => resposta.data);
  },
  notasFiscais: (filtro) => {
    return Vue.http.get('/api/notaFiscalConciliacao/Busca', { params: filtro })
      .then(resposta => resposta.data);
  },
  notaFiscal: (idNotaFiscal) => {
    return Vue.http.get('/api/notaFiscalConciliacao/' + idNotaFiscal)
      .then(resposta => resposta.data);
  },
  solicitacoesDevolucao: (filtro) => {
    return Vue.http.get('/api/devolucaoSolicitacaoConciliacao/Busca', { params: filtro })
      .then(resposta => resposta.data);
  },
  itemDevolucao: (idProjetoItemControle) => {
    return Vue.http.get('/api/devolucaoSolicitacaoConciliacao/Item/' + idProjetoItemControle)
      .then(resposta => resposta.data);
  },
  solicitacaoDevolucao: (idSolicitacao, conta = '', tipo = 'SP') => {
    return Vue.http.get('/api/devolucaoSolicitacaoConciliacao/' + idSolicitacao, { params: { conta, tipo } })
      .then(resposta => resposta.data);
  },
  pessoasCredito: (busca = '', tipoPessoa = 0) => {
    return Vue.http.get('/api/creditoIdentificar/Pessoas', { params: { busca, tipoPessoa } })
      .then(resposta => resposta.data);
  },
  categoriasFinanceiras: (busca = '') => {
    return Vue.http.get('/api/creditoIdentificar/CategoriasFinanceiras', { params: { busca } })
      .then(resposta => resposta.data);
  },
  impactoCorte: (data = '') => {
    return Vue.http.get('/api/creditoIdentificar/ImpactoCorte', { params: { data } })
      .then(resposta => resposta.data);
  },
  regularizarCredito: (idContaCript, payload) => {
    return Vue.http.post(`/api/creditoIdentificar/${idContaCript}/Regularizar`, payload)
      .then(resposta => resposta.data);
  },
  debitoTransitoria: (idContaCript, idLancamento) => {
    return Vue.http.get(`/api/creditoIdentificar/${idContaCript}/DebitoTransitoria`, { params: { idLancamento } })
      .then(resposta => resposta.data);
  },
  regularizarTransitoria: (idContaCript, payload) => {
    return Vue.http.post(`/api/creditoIdentificar/${idContaCript}/RegularizarTransitoria`, payload)
      .then(resposta => resposta.data);
  },
  glossarioIA: (numeroBanco = '') => {
    return Vue.http.get('/api/creditoIdentificar/Glossario', { params: { numeroBanco } })
      .then(resposta => resposta.data);
  },
  salvarGlossarioIA: payload => {
    return Vue.http.post('/api/creditoIdentificar/Glossario', payload)
      .then(resposta => resposta.data);
  },
  bancosGlossarioIA: () => {
    return Vue.http.get('/api/creditoIdentificar/GlossarioBancos')
      .then(resposta => resposta.data);
  },
  responderSugestaoIA: (idContaCript, payload) => {
    return Vue.http.post(`/api/conciliacaoProjeto/${idContaCript}/SugestaoIA`, payload)
      .then(resposta => resposta.data);
  },
  detectarOperacao: (idContaCript, idExtrato, idsExtrato = []) => {
    return Vue.http.post(`/api/operacaoConciliacao/${idContaCript}/Detectar`, { idExtrato, idsExtrato })
      .then(resposta => resposta.data);
  },
  aplicacoesConta: (idContaCript, busca = '') => {
    return Vue.http.get(`/api/operacaoConciliacao/${idContaCript}/Aplicacoes`, { params: { busca } })
      .then(resposta => resposta.data);
  },
  contasOperacao: (idContaCript, busca = '') => {
    return Vue.http.get(`/api/operacaoConciliacao/${idContaCript}/Contas`, { params: { busca } })
      .then(resposta => resposta.data);
  },
  tiposAplicacao: (busca = '') => {
    return Vue.http.get('/api/operacaoConciliacao/TiposAplicacao', { params: { busca } })
      .then(resposta => resposta.data);
  },
  codigoProjetoConta: (idContaCript, idContaAlvo, idsProjeto = []) => {
    return Vue.http.get(`/api/operacaoConciliacao/${idContaCript}/CodigoProjetoConta`, { params: { idContaAlvo, idsProjeto: idsProjeto.join(',') } })
      .then(resposta => resposta.data.codigo || '');
  },
  tiposAplicacaoConta: (idContaCript, busca = '') => {
    return Vue.http.get(`/api/operacaoConciliacao/${idContaCript}/TiposAplicacao`, { params: { busca } })
      .then(resposta => resposta.data);
  },
  previaAjusteDiferenca: (idContaCript, payload) => {
    return Vue.http.post(`/api/operacaoConciliacao/${idContaCript}/AjusteDiferenca/Previa`, payload)
      .then(resposta => resposta.data);
  },
  previaDescontoContaReceber: (idContaCript, payload) => {
    return Vue.http.post(`/api/operacaoConciliacao/${idContaCript}/DescontoContaReceber/Previa`, payload)
      .then(resposta => resposta.data);
  },
  ajustarDiferenca: (idContaCript, payload) => {
    return Vue.http.post(`/api/operacaoConciliacao/${idContaCript}/AjusteDiferenca`, payload)
      .then(resposta => resposta.data);
  },
  previaComplemento: (idContaCript, payload) => {
    return Vue.http.post(`/api/operacaoConciliacao/${idContaCript}/Complemento/Previa`, payload)
      .then(resposta => resposta.data);
  },
  detectarSaldo: (idContaCript, idsLancamento, idsExtrato) => {
    return Vue.http.post(`/api/operacaoConciliacao/${idContaCript}/DetectarSaldo`, { idsLancamento, idsExtrato: idsExtrato || [] })
      .then(resposta => resposta.data);
  },
  transferirSaldo: (idContaCript, payload) => {
    return Vue.http.post(`/api/operacaoConciliacao/${idContaCript}/TransferirSaldo`, payload)
      .then(resposta => resposta.data);
  },
  transferirEntreContas: (idContaCript, payload) => {
    return Vue.http.post(`/api/operacaoConciliacao/${idContaCript}/Transferir`, payload)
      .then(resposta => resposta.data);
  },
  solicitarTransferencia: (idContaCript, payload) => {
    return Vue.http.post(`/api/operacaoConciliacao/${idContaCript}/SolicitarTransferencia`, payload)
      .then(resposta => resposta.data);
  },
  usuariosLiberacao: (busca = '') => {
    return Vue.http.get('/api/operacaoConciliacao/Usuarios', { params: { busca } })
      .then(resposta => resposta.data);
  },
  projetosDaConta: (idContaCript, busca = '', natureza = 'C', idContaAlvo = 0) => {
    return Vue.http.get(`/api/operacaoConciliacao/${idContaCript}/ProjetosConta`, { params: { busca, natureza, idContaAlvo } })
      .then(resposta => resposta.data);
  },
  regraCategoria: (idContaCript) => {
    return Vue.http.get(`/api/operacaoConciliacao/${idContaCript}/RegraCategoria`)
      .then(resposta => resposta.data);
  },
  itensControle: (idContaCript, idProjeto = 0, idRubrica = 0, idSubRubrica = 0, busca = '', idLancamento = 0) => {
    return Vue.http.get(`/api/operacaoConciliacao/${idContaCript}/ItensControle`,
                        { params: { idProjeto, idRubrica, idSubRubrica, busca, idLancamento } })
      .then(resposta => resposta.data);
  },
  edicaoRateio: (idContaCript, idLancamento) => {
    return Vue.http.get(`/api/operacaoConciliacao/${idContaCript}/EdicaoRateio`, { params: { idLancamento } })
      .then(resposta => resposta.data);
  },
  salvarEdicaoRateio: (idContaCript, payload) => {
    return Vue.http.post(`/api/operacaoConciliacao/${idContaCript}/EdicaoRateio`, payload)
      .then(resposta => resposta.data);
  },
  verificarItemControle: (idContaCript, linha, natureza, idLancamento = 0) => {
    return Vue.http.get(`/api/operacaoConciliacao/${idContaCript}/ItensControle/Verificar`, {
      params: {
        idItem: linha.idItem || 0,
        idProjeto: linha.idProjeto || 0,
        idRubrica: linha.idRubrica || 0,
        idSubRubrica: linha.idSubRubrica || 0,
        valor: (+linha.valor || 0).toFixed(2),
        quantidade: String(+linha.quantidade || 1),
        natureza,
        idLancamento,
      },
    }).then(resposta => resposta.data);
  },
  lancarMovimento: (idContaCript, payload) => {
    return Vue.http.post(`/api/operacaoConciliacao/${idContaCript}/Movimento`, payload)
      .then(resposta => resposta.data);
  },
  lancarContaReceberConta: (idContaCript, payload) => {
    return Vue.http.post(`/api/operacaoConciliacao/${idContaCript}/ContaReceber`, payload)
      .then(resposta => resposta.data);
  },
  lancarAplicacao: (idContaCript, payload) => {
    return Vue.http.post(`/api/operacaoConciliacao/${idContaCript}/Aplicacao`, payload)
      .then(resposta => resposta.data);
  },
  lancarResgate: (idContaCript, payload) => {
    return Vue.http.post(`/api/operacaoConciliacao/${idContaCript}/Resgate`, payload)
      .then(resposta => resposta.data);
  },
  extratoContasLista: () => {
    return Vue.http.get('/api/conciliacaoProjeto/ExtratoContas')
      .then(resposta => normalizarEnvio(resposta.data));
  },
  extratoContasResumo: () => {
    return Vue.http.get('/api/conciliacaoProjeto/ExtratoContas/Resumo')
      .then(resposta => resposta.data);
  },
  enviarExtratoContas: arquivos => {
    return Vue.http.post('/api/conciliacaoProjeto/ExtratoContas', { arquivos })
      .then(resposta => resposta.data);
  },
  acompanharEnvioExtrato: jobId => {
    return Vue.http.get(`/api/conciliacaoProjeto/ExtratoContas/Job/${encodeURIComponent(jobId)}`)
      .then(resposta => resposta.data);
  },
  envioExtratoAtivo: () => {
    return Vue.http.get('/api/conciliacaoProjeto/ExtratoContas/JobAtivo')
      .then(resposta => resposta.data);
  },
  cabecalhoTesouraria: (horizonte = 1, ateData = '') => {
    return Vue.http.get('/api/posicaoTesouraria/Cabecalho', { params: { horizonte, ateData } })
      .then(resposta => resposta.data);
  },
  posicaoTesouraria: (pagina = 1, filtros = {}) => {
    const parametros = Object.assign({}, { pagina }, filtros);
    return Vue.http.get('/api/posicaoTesouraria', { params: parametros })
      .then(resposta => resposta.data);
  },
  exportarPosicaoTesouraria: (filtros = {}) => {
    return Vue.http.get('/api/posicaoTesouraria/Exportar', { params: filtros })
      .then(resposta => resposta.data);
  },
  contasTesouraria: () => {
    return Vue.http.get('/api/posicaoTesouraria/Contas')
      .then(resposta => resposta.data);
  },
  projetosTesouraria: () => {
    return Vue.http.get('/api/posicaoTesouraria/Projetos')
      .then(resposta => resposta.data);
  },
  detalheTesouraria: (idContaCript, dataReferencia = '', horizonte = 1, ateData = '') => {
    return Vue.http.get('/api/posicaoTesouraria/' + encodeURIComponent(idContaCript), { params: { dataReferencia, horizonte, ateData } })
      .then(resposta => resposta.data);
  },
  configuracaoTesouraria: () => {
    return Vue.http.get('/api/posicaoTesouraria/Configuracao')
      .then(resposta => resposta.data);
  },
  salvarConfiguracaoTesouraria: payload => {
    return Vue.http.post('/api/posicaoTesouraria/Configuracao', payload)
      .then(resposta => resposta.data);
  },
  compromissosTesouraria: (idContaCript, dataReferencia = '', horizonte = 1, ateData = '') => {
    return Vue.http.get('/api/posicaoTesouraria/' + encodeURIComponent(idContaCript) + '/Compromissos', { params: { dataReferencia, horizonte, ateData } })
      .then(resposta => resposta.data);
  },
  tratarTesouraria: (idContaCript, dataReferencia, observacao) => {
    return Vue.http.post('/api/posicaoTesouraria/' + encodeURIComponent(idContaCript) + '/Tratada', { dataReferencia, observacao })
      .then(resposta => resposta.data);
  },
  extratoAplicacoesConta: idContaCript => {
    return Vue.http.get('/api/aplicacaoConta/' + encodeURIComponent(idContaCript))
      .then(resposta => resposta.data);
  },
  extratoAplicacao: (idContaCript, idAplicacao, de = '', ate = '') => {
    return Vue.http.get('/api/aplicacaoConta/' + encodeURIComponent(idContaCript) + '/' + idAplicacao, { params: { de, ate } })
      .then(resposta => resposta.data);
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/conciliacao-projeto/servico.js